import React from "react";
import styled from "@emotion/styled";

import footerImage from "../../images/footer.png";
import youtubeIcon from "../../images/social-media/youtube.png";
import emailIcon from "../../images/social-media/email.png";
import tikTokIcon from "../../images/social-media/tiktok.png";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(${footerImage});
  background-size: cover;
  background-position: top center;
`;

const Title = styled.div`
  font-size: 7vw;
  color: white;
`;

const ContentLinksContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const SocialMediaButton = styled.img`
  width: 60px;
  height: 60px;
  margin: 10px;
`;

export const Footer: React.FC = () => {
  return (
    <Container>
      <Title>Let's be friends!</Title>
      <ContentLinksContainer>
        <a
          href="https://www.youtube.com/channel/UCJor4y7rj80m_LoLVR1Sueg"
          target="_blank"
        >
          <SocialMediaButton src={youtubeIcon} />
        </a>

        <a href="https://www.tiktok.com/@ajackster" target="_blank">
          <SocialMediaButton src={tikTokIcon} />
        </a>

        <a href="mailto:andrew.l.jackson300@gmail.com" target="_blank">
          <SocialMediaButton src={emailIcon} />
        </a>
      </ContentLinksContainer>
    </Container>
  );
};
